export default __webpack_public_path__ + "static/media/iPhone_redemption_locations.b631c9b7.png";